// extracted by mini-css-extract-plugin
export default {"overlay-modal":"modal_overlay-modal__NoofF","modal":"modal_modal__jHxYZ","close":"modal_close__mbbl3"};